import type { StrapiBaseRequest } from '@/interfaces/strapi';

export const queryParams: StrapiBaseRequest = {
	populate: {
		image: true,
	},
} as const;
